export const defaultUrl = process.env.REACT_APP_EMPLOYEES_URL;
export const apiServerUrl = process.env.REACT_APP_API_SERVER;
export const profileUrl = `${process.env.REACT_APP_PROFILE_URL}/profile`;
export const companyUrl = `${process.env.REACT_APP_PROFILE_URL}/company`;
